// ----------------------------------------------------------------------
const ROOTS = {
  AUTH: '/auth',
  APP: '/app',
};

// ----------------------------------------------------------------------

export const paths = {
  // AUTH
  auth: {
    login: `${ROOTS.AUTH}/login`,
    register: `${ROOTS.AUTH}/register`,
  },
  app: {
    root: ROOTS.APP,
    inactive: `${ROOTS.APP}/inactive`,
    safety: {
      root: `${ROOTS.APP}/safety`,
    },
    statements: {
      list: `${ROOTS.APP}/statements/list`,
      historic: `${ROOTS.APP}/statements/historic`,
      single: `${ROOTS.APP}/statements/:id`,
    },
    reminders: {
      list: `${ROOTS.APP}/reminders/list`,
    },
    accidents: {
      list: `${ROOTS.APP}/accidents/list`,
      closed: `${ROOTS.APP}/accidents/closed`,
    },
    revenueReports: {
      list: `${ROOTS.APP}/revenue-reports/list`,
      historic: `${ROOTS.APP}/revenue-reports/historic`,
      single: `${ROOTS.APP}/revenue-reports/:id`,
    },
    organization: {
      settings: `${ROOTS.APP}/organization/settings`,
    },
    organizationUsers: {
      list: `${ROOTS.APP}/organization-users/list`,
      single: `${ROOTS.APP}/revenue-reports/:id`,
    },
    profile: {
      edit: `${ROOTS.APP}/profile/edit`,
    },
    businessPartners: {
      list: `${ROOTS.APP}/business-partners/list`,
      inactive: `${ROOTS.APP}/business-partners/inactive`,
    },
    ifta: {
      list: `${ROOTS.APP}/ifta/list`,
      single: `${ROOTS.APP}/ifta/:id`,
    },
    loads: {
      list: `${ROOTS.APP}/loads/list`,
      historic: `${ROOTS.APP}/loads/historic`,
      single: `${ROOTS.APP}/loads/:id`,
    },
    fuelCharges: {
      list: `${ROOTS.APP}/fuel-charges/list`,
    },
    credits: {
      list: `${ROOTS.APP}/credits/list`,
    },
    tollCharges: {
      list: `${ROOTS.APP}/toll-charges/list`,
    },
    deductions: {
      list: `${ROOTS.APP}/deductions/list`,
    },
    eldIfta: {
      report: `${ROOTS.APP}/eld/eld-ifta/report`,
      mileageByVehicle: `${ROOTS.APP}/eld/eld-ifta/mileage-by-vehicle`,
    },
    eldDrivers: {
      list: `${ROOTS.APP}/eld/eld-drivers/list`,
      inactive: `${ROOTS.APP}/eld/eld-drivers/inactive`,
    },
    eldAssetsPerLandmark: {
      list: `${ROOTS.APP}/eld/eld-assets-per-landmark/list`,
    },
    eldLandmarks: {
      list: `${ROOTS.APP}/eld/eld-landmarks/list`,
    },
    eldAssetNotifications: {
      list: `${ROOTS.APP}/eld/eld-asset-notifications/list`,
    },
    reports: {
      root: `${ROOTS.APP}/eld/reports`,
      dormantAssets: `${ROOTS.APP}/reports/dormant-assets`,
      harshBreaking: `${ROOTS.APP}/reports/harsh-breaking`,
      vehicleOdometer: `${ROOTS.APP}/reports/vehicle-odometer`,
      iftaTrip: `${ROOTS.APP}/reports/ifta-trip`,
    },
    eldTrailersPerTruck: {
      list: `${ROOTS.APP}/eld/eld-trailers-per-truck/list`,
    },
    eldOrganizationSettings: {
      current: `${ROOTS.APP}/eld/eld-organization-settings`,
      organizations: `${ROOTS.APP}/eld/child-organization-settings`,
    },
    eldDormancySettings: {
      current: `${ROOTS.APP}/eld/eld-dormancy-settings`,
    },
    eldVehicles: {
      list: `${ROOTS.APP}/eld/eld-vehicles/list`,
    },
    eldUsers: {
      list: `${ROOTS.APP}/eld/eld-users/list`,
    },
    eldDvirs: {
      list: `${ROOTS.APP}/eld/eld-dvirs/list`,
    },
    eldDevices: {
      list: `${ROOTS.APP}/eld/eld-devices/list`,
    },

    rentals: {
      trailers: {
        list: `${ROOTS.APP}/rentals/trailers/list`,
        inactive: `${ROOTS.APP}/rentals/trailers/inactive`,
      },
      customers: {
        list: `${ROOTS.APP}/rentals/customers/list`,
        inactive: `${ROOTS.APP}/rentals/customers/inactive`,
      },
      organization: `${ROOTS.APP}/rentals/rental-organization-settings`,
    },
    eldDashboard: `${ROOTS.APP}/eld/dashboard`,
    eldDriverLogs: {
      list: `${ROOTS.APP}/eld/eld-driver-logs/list`,
      driver: `${ROOTS.APP}/eld/eld-driver-logs/driver`,
      single: `${ROOTS.APP}/eld/eld-driver-logs/single`,
    },
    eldAllLogs: {
      list: `${ROOTS.APP}/eld/eld-all-logs/list`,
    },
    eldInspections: {
      list: `${ROOTS.APP}/eld/eld-inspections/list`,
    },
    eldVehicleDtcHistory: {
      list: `${ROOTS.APP}/eld/eld-vehicle-dtc-history/list`,
    },
    eldUnidentifiedEvents: {
      list: `${ROOTS.APP}/eld/eld-unidentified-events/list`,
    },

    drivers: {
      list: `${ROOTS.APP}/drivers/list`,
      inactive: `${ROOTS.APP}/drivers/inactive`,
    },
    cameras: {
      root: `${ROOTS.APP}/cameras`,
      list: `${ROOTS.APP}/cameras/list`,
      notifications: {
        root: `${ROOTS.APP}/cameras/notifications`,
        list: `${ROOTS.APP}/cameras/notifications/list`,
      }
    },
    devices: {
      root: `${ROOTS.APP}/devices`,
      map: `${ROOTS.APP}/devices/map`,
      add: `${ROOTS.APP}/devices/add`,
    },
    trucks: {
      list: `${ROOTS.APP}/trucks/list`,
      inactive: `${ROOTS.APP}/trucks/inactive`,
    },
    debts: {
      list: `${ROOTS.APP}/debts/list`,
    },
    scheduledReports: {
      list: `${ROOTS.APP}/scheduled-reports/list`,
    },
    dots: {
      list: `${ROOTS.APP}/dots/list`,
    },
    maintenances: {
      root: `${ROOTS.APP}/maintenances`,
      reminders: `${ROOTS.APP}/maintenances/reminders`,
      performed: `${ROOTS.APP}/maintenances/performed`,
      settings: `${ROOTS.APP}/maintenances/settings`,
    },
    equipment: {
      list: `${ROOTS.APP}/equipment/list`,
      inactive: `${ROOTS.APP}/equipment/inactive`,
    },
  },
};
